module.exports = "/assets/e7f3093745219ff583919400b1ae8038.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XQ.png
// module id = 2005
// module chunks = 0